import log from 'salvo-lite/log'
import HcSticky from 'hc-sticky'

class Sticky {
    constructor (theme, elem) {
        this._elem = elem
        this._options = Object.assign({
            top: 60,
            bottomEnd: 0,
            stickTo: elem.closest('[data-sticky-container]') || elem.closest('section')
        }, JSON.parse(elem.dataset.sticky || '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (window.innerWidth > 768) {
            const Sticky = new HcSticky(this._elem, this._options)
            log.debug(this.constructor.name, 'Sticky', Sticky)

            document.addEventListener('update-sticky', () => {
                Sticky.update()
            })
        }
    }
}

export default Sticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Sticky.js